var _linearGradient, _path, _path2, _g, _ellipse, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYakOffice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1400.5 279.97",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 627.5,
    x2: 598.06,
    y1: 158.84,
    y2: 48.97
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ff4000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e60033"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m246.57 33.16 93.75 183.91h-53.57l-10.28-22.58h-59.76l-10.23 22.53h-53.39zm0 95.59-13.17 29h26.35z",
    fill: "#e60033",
    transform: "translate(0 -21.99)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m69.89 195.08v-63.94l-69.89-119.97h62.06l32.11 64.76 33.84-64.76h60.8l-66.24 119.97v63.94z",
    fill: "#e60033"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -21.99)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m737.3 35.35h115.37v44.43h-62.61v27h52.77v43.22h-52.77v67.15h-52.76z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m877.67 35.35h115.33v44.43h-62.57v27h52.76v43.22h-52.76v67.15h-52.76z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070.79 217.12h-52.79v-181.77h52.76z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1194.24 31.56c23.23 0 39.13 5.3 51.76 11.87v48a99 99 0 0 0 -46.45-11.62c-32.32 0-49.23 22.47-49.23 46.45 0 24.49 16.41 46.46 46.45 46.46a111.34 111.34 0 0 0 50.49-11.62v48.48c-12.62 6.56-33.58 11.36-55.54 11.36-54.53 0-94.42-41.91-94.42-94.68 0-52.03 39.89-94.7 96.94-94.7z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1275 35.35h121.68v44.43h-68.92v24.22h59.08v41.65h-59.08v27h72.71v44.43h-125.47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.69 174.65v42.42h-49.76v-183.91h49.76v78.32c18.84-25 38.07-52.25 57.72-78.32h60.37c-21.4 28-40.73 55.62-60.83 81.9 25.3 57.34 50.85 115.54 115.69 137.06 61.69 20.48 120.28 6.2 160.79-33-13.53 47-67.73 82.62-117.57 82.86-78.41.39-137.94-20.26-196.79-150.56-6.4 8.16-13.41 15.58-19.38 23.23z",
    fill: "#e60033"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 612.78,
    cy: 103.9,
    fill: "url(#a)",
    rx: 55.08,
    ry: 56.98
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m714.54 103.42-10-1.64a94.36 94.36 0 0 0 -11.05-25.78l5.62-7.78s-4.35-7.18-13.66-16.5-16.45-13.72-16.45-13.72l-8.24 5.91a94 94 0 0 0 -26.07-10.46l-1.58-9.45s-8.16-2-21.33-2-21.33 2-21.33 2l-1.64 10a94.36 94.36 0 0 0 -25.81 11l-7.78-5.62s-7.22 4.39-16.52 13.71-13.7 16.49-13.7 16.49l5.91 8.24a94.35 94.35 0 0 0 -10.45 26.07l-9.46 1.53s-2 8.16-2 21.33 2 21.33 2 21.33l10 1.64a94.1 94.1 0 0 0 11.06 25.83l-5.62 7.79s4.35 7.18 13.67 16.49 16.49 13.67 16.49 13.67l8.24-5.91a94.56 94.56 0 0 0 26.07 10.46l1.53 9.47s8.16 2 21.33 2 21.33-2 21.33-2l1.64-10a93.92 93.92 0 0 0 25.83-11.06l7.78 5.62s7.19-4.35 16.5-13.66 13.67-16.5 13.67-16.5l-5.91-8.24a94.56 94.56 0 0 0 10.46-26.07l9.46-1.53s2-8.16 2-21.33-1.99-21.33-1.99-21.33zm-102 68.27c-26.51 0-43.93-22-43.93-46.46 0-24 17.42-46.45 43.93-46.45 26.76 0 43.93 22.47 43.93 46.45.01 24.49-17.16 46.46-43.92 46.46z",
    fill: "#fff",
    transform: "translate(0 -21.99)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYakOffice);
export default __webpack_public_path__ + "static/media/YakOffice.f37262552a328a9401b2fe108df6f4fc.svg";
export { ForwardRef as ReactComponent };